// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-upload[data-v-0c4234b1]{background-color:#e7eaec}.list[data-v-0c4234b1]{list-style-type:\"✔\";-webkit-padding-start:3px;padding-inline-start:3px}", ""]);
// Exports
module.exports = exports;
